import { webcomponent } from '@adornis/functional-lit/webcomponent';
import { html } from 'lit';
import { LASUser } from '../../../db/las-user';

// Benutzerinitialen für Avatar ermitteln
export function getUserInitials(email: string): string {
  if (!email) return '?';
  const emailPart = email.split('@')[0] || '';
  const parts = emailPart.split(/[.-_]/);
  if (parts.length >= 2 && parts[0] && parts[1] && parts[0][0] && parts[1][0]) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return emailPart.substring(0, 2).toUpperCase();
}

// Generiere eine Hintergrundfarbe basierend auf der Benutzer-ID
export function getUserColor(userId: string): string {
  if (!userId) return 'bg-base-300';
  const colors = ['bg-primary', 'bg-secondary', 'bg-accent', 'bg-info', 'bg-success', 'bg-warning', 'bg-error'];
  const index = userId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
  return colors[index] ?? 'bg-base-300';
}

// Avatar-Komponente für einen Benutzer
export function UserAvatarFunc(user: LASUser, tooltip?: string) {
  return html`
    <div class="avatar placeholder cursor-pointer">
      <d-tooltip> <d-text>${tooltip || user.email}</d-text> </d-tooltip>
      <div
        class="w-8 h-8 rounded-full ${getUserColor(user._id)} flex items-center justify-center text-neutral-content"
        style="display: flex; align-items: center; justify-content: center; line-height: 1;"
      >
        <span style="transform: translateY(0); margin: 0; padding: 0;">${getUserInitials(user.email)}</span>
      </div>
    </div>
  `;
}

export const UserAvatar = webcomponent(
  'user-avatar',
  ({ user, tooltip }: { user: LASUser; tooltip?: string }) => {
    return UserAvatarFunc(user, tooltip);
  },
  { shadowRoot: true },
);

// Avatar-Komponente für einen nicht zugewiesenen Benutzer
export function EmptyAvatar(label: string) {
  return html`
    <div class="avatar placeholder cursor-pointer">
      <d-tooltip> <d-text>${label}</d-text> </d-tooltip>
      <div
        class="w-8 h-8 rounded-full bg-base-300 flex items-center justify-center border-dashed border-2 border-base-content"
        style="display: flex; align-items: center; justify-content: center; line-height: 1;"
      >
        <span style="transform: translateY(0); margin: 0; padding: 0;">+</span>
      </div>
    </div>
  `;
}
